import { Wrapper } from '@american-autonomy/ag-ui';

import getFillColor from 'components/DonutChart/getFillColor';

import {
    COLOR_MAP,
    FILL_COLOR_VARIABLE,
    FILL_WIDTH_VARIABLE,
    FULL_PERCENT,
    MINIMUM_PERCENT,
    TEST_ID
} from './constants';
import type { CSSProperties, FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const WearBar: FunctionComponent<Props> = ({
    className = '',
    percentRemaining,
    testId = TEST_ID
}) => {
    const filledPercent = Math.min(Math.max(percentRemaining, MINIMUM_PERCENT), FULL_PERCENT);

    const fillStyle = {
        [FILL_COLOR_VARIABLE]: getFillColor({ colorMap: COLOR_MAP, percent: filledPercent }),
        [FILL_WIDTH_VARIABLE]: `${filledPercent}%`
    } as CSSProperties;

    return (
        <Wrapper className={`${className} ${styles.wearBar}`} testId={testId}>
            <span className={styles.fill} style={fillStyle} />
        </Wrapper>
    );
};

export default WearBar;
